export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const {
      public: { BUILD_TIME },
    } = useRuntimeConfig();

    if (BUILD_TIME) {
      const when = new Date(BUILD_TIME).toLocaleString();
      console.info(`Build time: ${when}`);
    }
  }
});
